// Helper function to get the element's top offset
function getOffsetTop(el) {
	let offsetTop = 0;
	while(el) {
		offsetTop += el.offsetTop;
		el = el.offsetParent;
	}
	return offsetTop;
}

// Step 2: Create a function to check if the element is in the viewport
function isElementInViewport(el) {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	const elTop = getOffsetTop(el);
	const elBottom = elTop + el.offsetHeight;
    return elBottom > scrollTop;
}

// Step 3: Add an event listener for the scroll event
window.addEventListener('scroll', function() {
    // Step 1: Select the element
    const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add');
    const stickyElement = document.querySelector('.custom-sticky');
    const stickyQty = stickyElement.parentElement.querySelector('.custom-sticky-qty-selector');
    const quantitySelector = formElement.querySelector('.product-quantity__selector');
    if  (quantitySelector.value <= 99) {
        stickyQty.value = quantitySelector.value;
    } else {
        stickyQty.value = 99;
        quantitySelector.value = 99;
    }
    const addToCartButton = formElement.querySelector('button[type="submit"]');
    const stickyElementButton = stickyElement.querySelector('.custom-sticky .custom-sticky-add-cart-button');
    stickyElementButton.innerHTML = addToCartButton.innerHTML;
    updatePrice();
	// Check if the element is not in the viewport
	if (!isElementInViewport(formElement)) {
		// Step 4: Perform an action if the element is out of the viewport
        if(!stickyElement.classList.contains('show')){
            stickyElement.classList.add('show');
            // Select the body element
            const htmlElement = document.documentElement;
            // Calculate the new padding-bottom value
            const newPaddingBottomValue = stickyElement.offsetHeight;
            // Set the new padding-bottom value
            htmlElement.style.paddingBottom = `${newPaddingBottomValue}px`;
        }
	} else {
		// Step 5: Perform an action if the element is in the viewport
        if(stickyElement.classList.contains('show')){
            stickyElement.classList.remove('show');
            // Select the body element
            const htmlElement = document.documentElement;
            // Calculate the new padding-bottom value
            const newPaddingBottomValue = 0;
            // Set the new padding-bottom value
            htmlElement.style.paddingBottom = `${newPaddingBottomValue}px`;
        }
	}
});

const stickyChangeQtyButtons = document.querySelectorAll('.custom-sticky-qty-change');
stickyChangeQtyButtons.forEach(button => {
    button.addEventListener('click', changeQuantitySticky);
})
const stickyAddToCartButton = document.querySelector('.custom-sticky-add-cart-button');
stickyAddToCartButton.addEventListener('click', function(e) {  
    const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add"]');
    const addToCartButton = formElement.querySelector('button[type="submit"]');
    addToCartButton.click();
});
const stickyElement = document.querySelector('.custom-sticky');
const stickyQty = stickyElement.parentElement.querySelector('.custom-sticky-qty-selector');
stickyQty.addEventListener('input', function(e) {
    const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add');
    const quantitySelector = formElement.querySelector('.product-quantity__selector');
    if  (e.currentTarget.value <= 99) {
        quantitySelector.value = e.currentTarget.value;
    } else {
        e.currentTarget.value = 99;
        quantitySelector.value = 99;
    }
    updatePrice();
});
const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add');
const quantitySelector = formElement.querySelector('.product-quantity__selector');
quantitySelector.addEventListener('input', function(e) {
    const stickyElement = document.querySelector('.custom-sticky');
    const stickyQty = stickyElement.parentElement.querySelector('.custom-sticky-qty-selector');
    if  (e.currentTarget.value <= 99) {
        stickyQty.value = e.currentTarget.value;
    } else {
        e.currentTarget.value = 99;
        stickyQty.value = 99;
    }
    updatePrice();
});
function changeQuantitySticky(e) {
    const currentButton =  e.currentTarget;
    if ( ! currentButton.classList.contains('disabled') ) {
        const qty = currentButton.parentElement.querySelector('.custom-sticky-qty-selector');
        const action = currentButton.classList.contains('c-qty-minus') ? 'minus' : 'plus';
        const currentQty = parseInt(qty.value);
        if ( action == 'minus' && qty.value > 1) {
            qty.value = currentQty - 1;
            qty.dataset.currentQuantity = currentQty - 1;

        } 
        if( action == 'plus') {
            qty.value = currentQty + 1;
            qty.dataset.currentQuantity = currentQty + 1;
        }
        const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add');
        const quantitySelector = formElement.querySelector('.product-quantity__selector');
        quantitySelector.value = qty.value
        quantitySelector.dataset.currentQuantity = qty.dataset.currentQuantity
        updatePrice();
    }

}
function updatePrice() {
    const formElement = document.querySelector('form[action="'+window.Shopify.routes.root+'cart/add');
    const quantitySelector = formElement.querySelector('.product-quantity__selector');
    const stickyElement = document.querySelector('.custom-sticky');
    const stickyQty = stickyElement.parentElement.querySelector('.custom-sticky-qty-selector');
    stickyQty.value = quantitySelector.value;
    let displayPrice = (parseInt(stickyQty.value) * parseInt(stickyQty.dataset.currentPrice)); 
    const subscriptionButton = document.getElementById('subscriptionContainer');
    if (subscriptionButton && subscriptionButton.classList.contains('active')) {
        displayPrice = (displayPrice * 0.90);
    }
    const priceLabel = stickyElement.querySelector('.product-info-price span.price');
    displayPrice = isNaN(displayPrice) ? 0 : displayPrice;
    priceLabel.innerHTML = formatMoney(displayPrice, KROWN.settings.shop_money_format_with_currency);
}